import {Component} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import superMarketBudgetConfig from '../../../table/configs/super-market-budget.json';
import {RedistributionDialogComponent} from './redistribution-dialog/redistribution-dialog.component';


@Component({
  selector: 'app-sm-budget',
  templateUrl: './sm-budget.component.html'
})

export class SMBudgetComponent {

  private configuration: any;
  constructor(private matDialog: MatDialog) {
    this.configuration = superMarketBudgetConfig;
  }

  public openRedistributionDialog() {
    this.matDialog.open(RedistributionDialogComponent);
  }
}
